import {upperFirst} from "@lasalle/rich-content-utils/text/text";

const getSpecTitle = (specType) => specType.split('-').map((v) => upperFirst(v)).join(' ');

export default getSpecTitle;
